export const formatCurrency = (amount) => {
  return (
    "$" +
    Math.round(amount).toLocaleString("en-US", {
      maximumFractionDigits: 0,
      minimumFractionDigits: 0,
    })
  );
};

export const getBondFromGross = (gross) => {
  if (gross <= 75000) return 18000;
  if (gross <= 100000) return 25000;
  if (gross <= 175000) return 35000;
  if (gross <= 250000) return 50000;
  if (gross <= 500000) return 75000;
  return 100000 + Math.ceil((gross - 500000) / 500000) * 100000;
};
